import { render, staticRenderFns } from "./ProductionList.vue?vue&type=template&id=7976e23f&"
import script from "./ProductionList.vue?vue&type=script&lang=js&"
export * from "./ProductionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductionList.vue"
export default component.exports